import TextFormat from "../../components/TextFormat";
import { DataState } from "../../context/DataProvider";

const StepChatsCard = ({ chat }) => {
  const { userInfo } = DataState();
  const { role, content, is_error } = chat;
  const textContent = content;

  if (!textContent || !textContent.trim()) {
    return null;
  }

  return role === "bot" ? (
    <pre
      className="whitespace-pre-wrap break-words p-4 rounded-md text-gray-100 overflow-x-auto"
    >
      <TextFormat response={textContent} />
    </pre>
  ) : role === "tool" ? null : (
    <div className="flex gap-1 items-start">
      <div className="min-h-10 min-w-10 pt-3">
        {role === "user" ? (
          <img
            src={userInfo ? userInfo.picture : "../assets/nirmal.png"}
            alt="User"
            className="rounded-full h-7 w-7 object-cover"
          />
        ) : (
          <img
            src="../assets/logo.png"
            alt="Bot"
            className="rounded-full h-7 w-7 object-contain bg-black p-1"
          />
        )}
      </div>
      <p
        className={`text-sm ${role === "user" ? "text-zinc-200" : "text-zinc-300"
          }`}
      >
        <TextFormat response={textContent} />
      </p>
    </div>
  );
}

export default StepChatsCard;